import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {pullRequestsLayoutRoute} from '../../routes/layout-route'
import {useRouteQueryKey} from '@github-ui/react-core/future/use-route-query-key'

export function useLayoutRouteData() {
  const {data, ...rest} = useRouteQuery(pullRequestsLayoutRoute, 'mainQuery')
  return {...data, ...rest}
}

export function useLayoutRouteQueryKey() {
  return useRouteQueryKey(pullRequestsLayoutRoute, 'mainQuery')
}
